import { fromPairs, KeyValuePair, unnest } from 'ramda';

import { fieldsForApproving, IFieldForApprovingContext } from '../constants/fieldsForApproving';
import { knmErknmGetFillStatusByField } from './knmErknmGetFillStatusByField';

export const getApprovingFieldsStatus = (context: IFieldForApprovingContext) => {
  const { values } = context;
  const nestedFields: (boolean | string)[][] = [];

  const fields = fieldsForApproving.map(currentField => {
    const { name, nested } = currentField;

    if (nested) {
      const currentValue = values[name];
      const resultArray =
        Array.isArray(currentValue) &&
        currentValue.map(
          (item, index) =>
            item &&
            nested.map(nestedItem => {
              const { typeCode } = nestedItem;

              if (typeCode && typeCode !== values.typeErknm?.code) {
                return [`${name}[${index}].${nestedItem.name}`, undefined];
              }

              return [
                `${name}[${index}].${nestedItem.name}`,
                knmErknmGetFillStatusByField({
                  name: nestedItem.name,
                  value: Object.entries(item).find(entry => entry[0] === nestedItem.name)?.[1],
                  isNested: true,
                  pairedByNestedValue: Object.entries(item).find(entry => entry[0] === nestedItem.pairedName)?.[1],
                  context,
                }),
              ];
            }),
        );

      if (Array.isArray(resultArray)) {
        nestedFields.push(...(unnest(resultArray) as (boolean | string)[][]));

        return [];
      }
    }

    const currentValue = values[name];

    const pairedValues = values
      ? fromPairs(
          Object.entries(values).filter(item =>
            fieldsForApproving.find(
              field => field.name === name && field.paired?.find(pairedItem => pairedItem.name === item[0]),
            ),
          ),
        )
      : undefined;

    return [name, knmErknmGetFillStatusByField({ name, value: currentValue, pairedValues, context })];
  });
  const pairs = [...fields.filter(item => typeof item[1] === 'boolean'), ...nestedFields] as KeyValuePair<
    string,
    boolean | undefined
  >[];

  return fromPairs(pairs);
};
